import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./TabImage.css"; // Optional CSS
import { useAssets } from "../assets/AssetsContext";

const TabImage = () => {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  const tabs = [
    { name: "Tonnes of CO₂e removed & locked", image: assets.co2 },
    { name: "Tons of biomass upcycled", image: assets.biomass },
    { name: "Hectares of land regenerated", image: assets.land },
    { name: "Liters of water filtered", image: assets.water },
    { name: "Rural jobs created per unit deployed", image: assets.jobs },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="tab-container">
      <div className="tab-image">
        <img src={tabs[activeIndex].image} alt={tabs[activeIndex].name} />
      </div>
      <div className="tab-buttons">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={activeIndex === index ? "active" : ""}
            onClick={() => setActiveIndex(index)}
          >
            {tab.name}
          </button>
        ))}
      </div>
      <div className="text-center">
        {/* <a href="#" className="button-1">
          Download Impact Sheet
        </a> */}
      </div>
    </div>
  );
};

export default TabImage;
